import { Dialog } from '@headlessui/react'
import React from 'react'
import Button from 'components/ui/Button'
import { useTruckCreateUserFeedback } from 'components/pages/LotPage/FeedbackModal/types/truckCreateUserFeedback'
import FormTextAreaField from 'components/ui/FormTextAreaField'
import { Form } from 'react-final-form'
import { SubmitErrors } from 'components/pages/ProfilePage/EditProfileForm'
import getMutationErrors from 'utils/getMutationErrors'
import FormError from 'components/ui/FormError'

type Props = {
  isOpen: boolean
  onClose: () => void
  lotId: number
  truckId: number
}

type SubmitValue = {
  feedback: string
}

const FeedbackModal = ({ isOpen, onClose, lotId, truckId }: Props) => {
  const [createUserFeedback] = useTruckCreateUserFeedback()

  const onCreateUserFeedback = async (values: SubmitValue) => {
    const response = await createUserFeedback({
      variables: {
        lotId,
        truckId,
        text: values.feedback
      }
    })
    const errors = getMutationErrors(response!)
    if (errors) {
      return errors
    }

    onClose()

    return null
  }

  const validate = (values: SubmitValue) => {
    const errors: SubmitErrors = {}
    if (!values.feedback) {
      errors.feedback = 'Required'
    }
    return errors
  }

  return (
    <Dialog className="relative z-50" onClose={onClose} open={isOpen}>
      <Dialog.Overlay
        className="fixed inset-0"
        style={{
          backgroundColor: 'rgba(0,0,0,0.53)'
        }}
      />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Dialog.Panel className="flex flex-col gap-6 w-full max-w-2xl my-8 mx-4 p-6 overflow-hidden text-left align-middle transition-all bg-white shadow-xl rounded-lg">
            <Dialog.Title className="text-2xl mt-2 font-bold leading-6 text-gray-900">
              Vendor feedback
            </Dialog.Title>
            <Dialog.Description>
              We always try to bring you the best food vendors so your opinion
              is very valuable to us. Let us know if you want the vendor back or
              why you won&apos;t be ordering from this vendor.
            </Dialog.Description>

            <Form<SubmitValue>
              onSubmit={onCreateUserFeedback}
              validate={validate}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <FormError className="mb-8" />

                  <FormTextAreaField
                    name="feedback"
                    placeholder="Type your message here..."
                    rows={5}
                  />

                  <div className="flex mt-4 gap-x-4 justify-end">
                    <Button
                      color="secondary"
                      onClick={onClose}
                      variant="outline"
                      fullWidth
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onClick={handleSubmit}
                      variant="contained"
                      fullWidth
                    >
                      Send
                    </Button>
                  </div>
                </form>
              )}
            </Form>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  )
}
export default FeedbackModal
